<!-- 
  远程搜索多选框 组件
  props:
    attrValue: 默认绑定值
    customerId: 详情页id
    module 模块名
  emit: 
    emitObj: 提交已选数据
 -->
 
<template>
  <div class="mult-select">
    <el-dialog :title="'选择'+title" :visible.sync="dialogVisible" :modal="false">
      <div class="content">
        <div class="search">
          <el-input size="small" prefix-icon="el-icon-search" v-model="contactSearch" @change="handleSearch" placeholder="输入关键词进行搜索">
          </el-input>
        </div>
        <div class="select-list">
          <el-table
            ref="table"
            :data="userList"
            v-loading.body="loading"
            row-key="id"
            border
            style="width: 100%"
            @select="handleSelect">
            <el-table-column
              type="selection"
              width="50">
            </el-table-column>
            <el-table-column
              prop="value"
              label="名称">
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper" v-show="total > pageSize">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <span class="select">已选：{{selectContacts.length}}</span>
        <el-button type="primary"  @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
let lazy
const dataMap = {
  customer: '/customerApi/getCustomers.html',
  contact: '/contactApi/getContacts.html',
  contract: '/contractApi/getContractList.html',
  payment: '/paymentApi/getPaymentList.html'
}

export default {
  created () {
    this.getUserList()
  },
  props: {
    attrValue: {
      type: Array,
      default: () => []
    },
    customerId: {
      type: Number
    },
    module: {
      Type: String,
      default: 'contact'
    },
    contractId: {
      type: Number
    }
  },
  data () {
    return {
      contactSearch: '',
      userList: [],
      selectContacts: this.attrValue.slice(),
      selectClass: false,
      // 分页信息
      currentPage: 1,
      total: 0,
      dialogVisible: false,
      pageSize: 7,
      loading: false
    }
  },
  computed: {
    // 包含已选产品id的数组
    idArr () {
      return this.selectContacts.map((item) => item.id)
    },
    title () {
      switch (this.module) {
        case 'contact' :
          return '联系人'
        case 'customer' :
          return '客户'
        case 'contract' :
          return '合同'
        case 'payment' :
          return '回款单'
        default:
          return '客户'
      }
    }
  },
  methods: {
    // 选中事件
    handleSelect (selection, row) {
      const index = this.idArr.indexOf(row.id)
      if (index === -1) {
        let object = {
          id: row.id,
          value: row.value
        }
        if (typeof (row.amount) === 'number') {
          object.amount = row.amount || 0
        }
        if (row.contractNo) {
          object.contractNo = row.contractNo
        }
        this.selectContacts.push(object)
      } else {
        this.selectContacts.splice(index, 1)
      }
    },
    // 获取联系人
    getUserList (query) {
      this.loading = true
      let url = dataMap[this.module]
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        customerId: this.customerId,
        nameLike: query || ''
      }
      if (this.contractId) {
        params.contractId = this.contractId
      }
      api.post(url, params, (data) => {
        this.loading = false
        this.userList = data.result
        this.total = data.pageHelper.rowsCount || 0
        this.dialogVisible = true

        // checkbox初始化
        this.$nextTick(() => {
          this.userList.forEach((item) => {
            const index = this.idArr.indexOf(item.id)
            if (index > -1) {
              this.$refs.table.toggleRowSelection(item, true)
            }
          })
        })
      })
    },
    // 远程搜索
    handleSearch (query) {
      query = query.toString().trim()
      window.clearTimeout(lazy)
      lazy = window.setTimeout(() => { this.getUserList(query) }, 500)
    },
    // 每页所显示的条数变更
    handleSizeChange (val) {
      this.pageSize = val
      this.getUserList()
    },
    // 当前分页变更
    handleCurrentChange (val) {
      this.currentPage = val
      this.getUserList()
    },
    // 提交已选数据
    handleSubmit () {
      this.$emit('emitObj', this.selectContacts)
      this.dialogVisible = false
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="less">
  .mult-select {
    .el-dialog--small {
      width: 400px;
    }
    .el-dialog__header, .el-dialog__footer {
      line-height: 1;
    }
    .el-dialog__body {
      padding: 0;
      min-height: 400px;
      overflow: auto;
    }
    .content {
      width: 99%;
      .search {
        padding: 9px;
      }
      .select-list {
        flex: 1;
        .el-table__header {
          .el-checkbox {
            display: none;
          }
        }
      }
      .pagination-wrapper {
        padding: 8px 0;
      }
    }
    .dialog-footer {
      position: relative;
      .select {
        position: absolute;
        left: 200px;
        top: 4px;
        padding: 6px 15px;
        border-radius: 13px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// mult-select.vue?ded011c4